<template>
    <b-row>
        <b-col cols="12" class="text-center">
            <h2>{{ tituloSimpatizantes }}</h2>
            <p class="subtitle">{{ $t("perfil_sga.subtitulo_simpatizantes", { simpatizante: textoSimpatizante }) }}</p>
        </b-col>
        <b-col>
            <div v-if="loading" style="height: 200px">
                <LoaderComponent />
            </div>
            <div v-else-if="!perfiles.data || perfiles.data.length === 0" class="text-center pt-4 pb-5">
                <div>
                    <b-icon icon="bag-x" class="mb-3"/>
                    <h4>{{ $t("perfil_sga.sin_simpatizantes") }}</h4>
                    <p>{{ $t("perfil_sga.mensaje_sin_simpatizantes") }}</p>
                </div>
            </div>

            <div v-else class="row col-12 col-md-10 mx-auto px-0">
                <div
                    class="w-100"
                    v-for="(perfil, index) in perfiles.data"
                    :key="index"
                >
                    <b-card class="border-0 mb-4" style="box-shadow: 0 0 6px rgba(0, 0, 0, 0.2);">
                        <b-card-header class="card-header p-0 d-flex align-items-center">
                            <b-button
                                class="w-100 d-flex text-dark border-0 bg-transparent py-3 pl-3 pr-1"
                                v-b-toggle="'perfil-' + index"
                                @click="toggleCollapse(index)"
                            >
                                <div class="w-100 d-flex justify-content-between d-md-block">
                                    <div class="w-auto d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center pr-0 pr-md-4">
                                        <div class="w-auto d-flex flex-column flex-md-row align-items-start align-items-md-center">
                                            <div class="border d-none d-lg-flex align-items-center justify-content-center p-1 mr-3 rounded-circle overflow-hidden mb-2 mb-md-0" style="width: 50px; height: 50px;">
                                                <b-icon icon="person" class="w-100 h-100"/>
                                            </div>
                                            <div>
                                                <div class="d-flex mb-2">
                                                    <p class="mb-0 mr-2"> {{ perfil.profile.name }}</p>
                                                    <p class="mb-0"> {{ perfil.profile.lastName }} </p>
                                                </div>
                                                <div class="d-flex mb-1 mb-md-0 font-weight-normal">
                                                    <b-icon icon="calendar-3" class="mr-2" />
                                                    <p class="mb-0"> {{ perfil.profile.birthday }} </p>
                                                </div>
                                            </div>
                                        </div>
                                        <div>
                                            <div class="d-flex font-weight-normal mb-2">
                                                <b-icon icon="card-text" class="mr-2" />
                                                <p class="mb-0"> {{ perfil.profile.identification.value }} </p>
                                            </div>
                                            <div class="d-flex font-weight-normal">
                                                <b-icon icon="telephone" class="mr-2" />
                                                <p class="mb-0"> +{{ perfil.profile.phone }} </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="d-flex align-items-start align-items-md-center justify-content-end" style="min-width: fit-content;">
                                    <p class="mb-0 d-none d-md-block" style=" font-size: 11px; font-weight: 400; min-width: 105px;"> {{ abrirSimpatizantes[index] ? $t("perfil_sga.ocultar_simpatizantes") : $t("perfil_sga.mostrar_simpatizantes") }} </p>
                                    <b-icon :icon="abrirSimpatizantes[index] ? 'chevron-up' : 'chevron-down'" class="ml-0 ml-md-2"/>
                                </div>
                            </b-button>
                        </b-card-header>

                        <b-collapse :id="'perfil-' + index">
                            <b-card-body>
                                <b-col cols="12" v-for="(membresia, membresiaIndex) in perfil.membresias" :key="membresiaIndex">
                                    <div class="p-3 w-100" v-if="membresia?.id">
                                        <div class="d-flex align-items-center w-100 mb-2">
                                            <div class="d-flex align-items-center">
                                                <div class="border d-none d-lg-flex align-items-center justify-content-center p-2 rounded-circle overflow-hidden mb-2 mb-md-0" style="width: 50px; height: 50px;">
                                                    <b-icon icon="card-text" class="w-100 h-100" />
                                                </div>
                                                <div>
                                                    <p class="mb-0 ml-0 ml-lg-3 small"><strong>Nº Simpatizante:</strong> {{ membresia?.n_abonado }} </p>
                                                    <p v-if="membresia?.temporada" class="mb-0 ml-0 ml-lg-3 small text-muted">
                                                        {{ membresia?.temporada }}
                                                    </p>
                                                </div>
                                            </div>
                                            <div class="ml-auto d-flex align-items-center">
                                                <b-dropdown v-if="canShowRenovacionButton(membresia)" variant="link" toggle-class="border-0 bg-transparent p-0" no-caret right>
                                                    <template #button-content>
                                                        <b-icon icon="three-dots-vertical" class="border-0 mx-3 mx-md-2" style="width: 18px;"/>
                                                    </template>
                                                    <b-dropdown-item @click="openRenovacionModal(membresia)">
                                                        {{ $t('perfil_sga.renovar_membresia', { simpatizante: textoSimpatizante }) }}
                                                    </b-dropdown-item>
                                                </b-dropdown>
                                            </div>
                                        </div>
                                        <div class="w-100 small d-flex flex-column flex-md-row py-2">
                                            <div class="col-md-6 d-flex flex-column p-0">
                                                <div class="mb-2 px-0 d-flex flex-row align-items-start align-items-md-center">
                                                    <b-icon icon="currency-euro" class="mr-2" />
                                                    <strong class="mr-2 mr-md-1">{{ $t("perfil_sga.precio") }}:</strong>
                                                    <span>{{ membresia?.precio | formatear_precio }}</span>
                                                </div>
                                            </div>
                                            <div class="col-md-6 d-flex flex-column p-0">
                                                <div class="mb-2 px-0 d-flex flex-row align-items-start align-items-md-center">
                                                    <b-icon icon="calendar" class="mr-2" />
                                                    <strong class="mr-2 mr-md-1">{{ $t("perfil_sga.fecha_alta") }}:</strong>
                                                    <span>{{ membresia?.fecha_alta }}</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="font-weight-normal d-flex align-items-center mb-2">
                                            <span :class="membresia?.activo_temporada_actual == 'Active' ? 'text-success' : 'text-danger'">
                                                <i :class="membresia?.activo_temporada_actual == 'Active' ? 'fas fa-check' : 'fas fa-times'"></i>
                                                {{ membresia?.activo_temporada_actual == 'Active' ? $t('perfil_sga.activo') : $t('perfil_sga.inactivo') }}
                                            </span>
                                        </div>
                                        <div class="col-12 col-md-2 d-flex align-items-center flex-column flex-md-row mt-1 p-0">
                                            <div v-if="membresia?.sga_apple_wallet_url" class="w-100 mb-2 mr-md-3">
                                                <button class="btn-wallet" @click="openWallet(membresia.sga_apple_wallet_url)">
                                                    <img src="@/assets/icons/apple.svg" alt="apple icon" class="mr-2" style="width: 16px; height: 16px;"/>
                                                    <p class="mt-1 mb-0">wallet</p>
                                                </button>
                                            </div>
                                            <div v-if="membresia?.sga_google_wallet_url" class="w-100 mb-2 mr-md-3">
                                                <button class="btn-wallet" @click="openWallet(membresia.sga_google_wallet_url)">
                                                    <b-icon icon="google" class="mr-2" style="width: 15px; height: 15px;"/>
                                                    <p class="mt-1 mb-0">wallet</p>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                    <div v-else class="p-3 w-100">
                                        Error al recuperar la información del simpatizante.
                                    </div>
                                    <hr v-if="membresiaIndex + 1 != perfil.membresias.length"/>
                                </b-col>
                            </b-card-body>
                        </b-collapse>
                    </b-card>
                </div>
            </div>
        </b-col>
        <RenovacionMembresiaSgaModal
            v-if="showRenovacionModal"
            :abonado_id="selectedMembresiaForRenewal"
            :can_renew="selectedRenewalInfo?.can_renew === true"
            :renewal_periods="selectedRenewalInfo?.renewal_periods || []"
            :sales_category_id="selectedRenewalInfo?.sales_category_id"
            :gastos_gestion="selectedRenewalInfo?.gastos_gestion || 0"
            :status="selectedRenewalInfo?.status ?? null"
            @close="closeRenovacionModal"
        />
    </b-row>
</template>

<script>
    import LoaderComponent from "@/components/preloader/LoaderComponent";
    import RenovacionMembresiaSgaModal from "./RenovacionMembresiaSgaModal.vue";

    export default {
        data() {
            return {
                perfiles: [],
                loading: false,
                abrirSimpatizantes: {},
                showRenovacionModal: false,
                selectedMembresiaForRenewal: null,
                selectedRenewalInfo: null,
            };
        },
        computed: {
            // Label of the membership type, taken from the theater config
            // (texto_simpatizante) instead of hardcoding "membresía".
            textoSimpatizante() {
                return this.$store.getters.getTeatro?.texto_simpatizantes || '';
            },
            // Title of the memberships list: pluralized and capitalized,
            // e.g. "simpatizante" -> "Simpatizantes".
            tituloSimpatizantes() {
                const word = this.textoSimpatizante;
                if (!word) return '';
                const plural = word.endsWith('s') ? word : word + 's';
                return plural.charAt(0).toUpperCase() + plural.slice(1);
            },
        },
        mounted() {
            this.getMembresias();
        },
        methods: {
            getMembresias() {
                this.loading = true;
                const params = {
                    filters: {
                        page: 1,
                    },
                }

                this.$store.dispatch(this.config.getVuexAlias("front.perfil.membresias.sga"), params).then(res => {
                    this.perfiles = res.data;
                    // The refresh replaced the membership objects, dropping
                    // their cached _renewalInfo (which gates the "renovar"
                    // button). Re-fetch it for the profiles whose collapse is
                    // currently open so the button stays visible.
                    Object.keys(this.abrirSimpatizantes).forEach(id => {
                        if (this.abrirSimpatizantes[id]) {
                            this.fetchRenewalInfoForProfile(id);
                        }
                    });
                })
                    .catch(() => {
                        this.$toast.error(this.$t('perfil_sga.error_obtener_simpatizantes'));
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            },
            toggleCollapse(id) {
                const wasOpen = this.abrirSimpatizantes[id];
                this.$set(this.abrirSimpatizantes, id, !wasOpen);

                // When opening, fetch renewal info for all memberships in this profile
                if (!wasOpen) {
                    this.fetchRenewalInfoForProfile(id);
                }
            },
            fetchRenewalInfoForProfile(id) {
                if (this.perfiles?.data?.[id]?.membresias) {
                    this.perfiles.data[id].membresias.forEach(membresia => {
                        if (membresia?.id) {
                            this.fetchRenewalInfo(membresia);
                        }
                    });
                }
            },
            fetchRenewalInfo(membresia) {
                // Guard: skip if already fetched or already loading (un
                // cierre/apertura rápido no debe lanzar dos renewal-info).
                if (membresia._renewalInfo || membresia._renewalLoading) {
                    return;
                }

                this.$set(membresia, '_renewalLoading', true);

                this.$store.dispatch(this.config.getVuexAlias('sga.profile.membresias.renewal-info'), { abonado_id: membresia.id })
                    .then(res => {
                        this.$set(membresia, '_renewalInfo', res.data?.data || res.data || {});
                    })
                    .catch(error => {
                        if (process.env.NODE_ENV === 'development') {
                            console.error('Error fetching membership renewal info:', error);
                        }
                        this.$set(membresia, '_renewalInfo', { can_renew: false });
                    })
                    .finally(() => {
                        this.$set(membresia, '_renewalLoading', false);
                    });
            },
            canShowRenovacionButton(membresia) {
                // No manager flag gates memberships (unlike abonos). The
                // per-membresia info has to report can_renew + at least one
                // renewal period — unless status.value === 2 (blocked), in
                // which case we still surface the option so the user can read
                // the blocked message instead.
                const info = membresia._renewalInfo;
                if (info?.status?.value === 2) return true;

                return (
                    info?.can_renew === true &&
                    Array.isArray(info?.renewal_periods) &&
                    info.renewal_periods.length > 0
                );
            },
            openRenovacionModal(membresia) {
                const info = membresia._renewalInfo;
                this.selectedMembresiaForRenewal = String(membresia.id);
                this.selectedRenewalInfo = info;
                // Force a fresh modal instance. If a previous modal was closed
                // via outside click / ESC, vue-js-modal hides it without
                // emitting `close`, so showRenovacionModal stayed true and the
                // old instance (with its payment step state) would be reused.
                // Toggling guarantees a clean instance with reset state.
                this.showRenovacionModal = false;
                this.$nextTick(() => {
                    this.showRenovacionModal = true;
                    this.$nextTick(() => {
                        this.$modal.show('renovacion-membresia-sga-modal');
                    });
                });
            },
            closeRenovacionModal() {
                this.$modal.hide('renovacion-membresia-sga-modal');
                this.showRenovacionModal = false;
                this.selectedMembresiaForRenewal = null;
                this.selectedRenewalInfo = null;
                // Refresh the list so the renewed membership reflects the new state
                this.getMembresias();
            },
            openWallet(url) {
                if (url) {
                    window.open(url, '_blank');
                    this.$toast.success(this.$t('perfil_sga.simpatizante_descargado'));
                }
            },
        },
        components: {
            LoaderComponent,
            RenovacionMembresiaSgaModal,
        },
    }
</script>

<style scoped>
.btn-wallet {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    padding: 4px 12px;
    background-color: #ffffff;
    color: #343a40;
    border: none;
    border-radius: 6px;
    font-size: 12px;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
    transition: all 0.25s ease-in-out;
    cursor: pointer;
    text-transform: uppercase;
}

.btn-wallet:hover {
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.4);
    transform: translateY(-1px);
    scale: 1.05;
}
.card-body {
    padding: 0 !important;
}

::v-deep .dropdown-toggle .bi-three-dots-vertical {
    color: #000;
}

::v-deep .dropdown-toggle .bi-three-dots-vertical:hover {
    color: gray;
}
</style>
